export default __webpack_public_path__ + "locales/it/Settings.json?hash=4cc2d698885d3d4b36586a724ac3cd88";